import { Dialog, DialogTitle, DialogContent, ListItemButton, ListItemText } from '@mui/material'
import { useSitesContext } from '../context'

const SeleccionarObraDialog = ({ open, handleClose }) => {
    const { sitesToSelection, setSiteSelected } = useSitesContext()

    const handleSiteSelection = (siteObject) => {
        setSiteSelected(siteObject)
        setTimeout(() => {
            handleClose('Selected')
        }, 500)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Seleccione Obra</DialogTitle>
            <DialogContent>
                {
                    sitesToSelection.map((obra, i) => {
                        return (
                            <ListItemButton key={i} onClick={() => handleSiteSelection(obra)}>
                                <ListItemText
                                    primary={
                                        obra.idObra && obra.idObra !== 'none' && obra.idObra !== 'universal' ? (
                                            <>
                                                <span style={{ fontSize: '0.75rem', color: '#757575', marginRight: '6px' }}>
                                                    {obra.idObra}
                                                </span>
                                                <span style={{ marginRight: '6px' }}>-</span>
                                                <span>{obra.descripcion}</span>
                                            </>
                                        ) : (
                                            obra.descripcion
                                        )
                                    }
                                />
                            </ListItemButton>
                        )
                    })
                }
            </DialogContent>
        </Dialog>
    )
}

export default SeleccionarObraDialog
